// @flow

export type BrazeContentCard = {
  id: string,
  title: string,
  description: string,
  imageUrl?: string | null,
  linkText: string,
  url: string,
  clicked: boolean,
  dismissed: boolean,
  dismissible: boolean,
  pinned: boolean,
  viewed: boolean,
  sc?: string
};

export type SetBrazeContentCardsAction = {
  type: "SET_BRAZE_CONTENT_CARDS",
  payload: {
    unviewed: number,
    totalCards: number,
    cards: BrazeContentCard[]
  }
};

export const setBrazeContentCards = (contentCards: {
  unviewed: number,
  totalCards: number,
  cards: BrazeContentCard[]
}): SetBrazeContentCardsAction => ({
  type: "SET_BRAZE_CONTENT_CARDS",
  payload: contentCards
});
